module.exports = __webpack_public_path__ + "img/collection-diamondJewelry025Carat.3d02574.webp";